import React from "react";
import * as CHQ from "chq";
import { DefaultProfile } from "app/context/ProfileContext";
import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type ActivatingTemplateNotificationProps = {
  notification: CHQ.NotificationProcessingTemplate;
  profile?: CHQ.Profile | DefaultProfile;
  tabIndex?: number;
};

const isDraft = (status: string) => status === "draft";

const ActivatingTemplateNotification: React.FC<ActivatingTemplateNotificationProps> = ({
  notification: { entity }, profile, tabIndex
}) => (
  <NotificationBody actor={profile as CHQ.Creator}>
    <Trans>Your template</Trans>
    {" "}
    {(entity as CHQ.Template)?.name}
    {" "}
    <Trans>is being {isDraft(entity.status as string) ? "created" : "activated"}. We will let you know as soon as it is ready.</Trans>
  </NotificationBody>
);

export default ActivatingTemplateNotification;
